import * as React from 'react';

import {
  Card,
  Stack,
  Heading,
  Text,
  TextLink,
  Columns,
  Column,
  Divider,
} from '@origin-digital/ods-core';
import { BpayIcon, IIconProps } from '@origin-digital/icon';

import { Definition } from 'src/components/Definition';

import * as content from './content.json';

const HeadingWithIcon: React.SFC<{
  icon: React.FunctionComponent<IIconProps>;
  children: string;
}> = ({ icon: Icon, children }) => (
  <Columns space="xsmall">
    <Column width="content">
      <Icon />
    </Column>
    <Column>
      <Heading variant="h4">{children}</Heading>
    </Column>
  </Columns>
);

export const OtherPaymentCard: React.SFC = () => (
  <Card data-id="other-payment-card">
    <Stack space={['large', 'xlarge']}>
      <HeadingWithIcon icon={BpayIcon}>{content.bpay.heading}</HeadingWithIcon>
      <Stack space="small">
        <Stack data-id="definitions" space="small" dividers>
          {content.bpay.definitions.map(({ label, text }, idx) => (
            <Definition label={label} key={idx} size="sm">
              {text}
            </Definition>
          ))}
        </Stack>
        <Divider />
      </Stack>

      <Stack space={['medium', 'large']}>
        <Heading variant="h4">{content.other.heading}</Heading>

        <Text tone="critical">
          <TextLink href={content.other.link.href} data-id="all-ways-to-pay" target="_blank">
            {content.other.link.text}
          </TextLink>
        </Text>
      </Stack>
    </Stack>
  </Card>
);
